module.exports = __webpack_public_path__ + "img/yml_main1.7045892b.jpg";